var tianzhao = [
    {
        "skillName": "月碎",
        "skillProperty": [
            "物理攻击",
            "瞬发技能"
        ],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_1a9cbab4-9ffa-4e48-8601-0937045decff_1901",
        "skillDescribe": {
            "main": "对前方矩形范围的敌方造成少量伤害",
            "static": [
                "挥出剑气，对前方矩形范围的敌方造成少量伤害"
            ],
            "addition": [],
            "trainingName": [
                "剑",
                "悟",
                "龙"
            ],
            "training": [
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "本技能造成的物理伤害提升5%"
                            },
                            {
                                "layer": 4,
                                "value": "本技能造成的物理伤害提升10%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "所有技能造成的破绽效果可叠加3层，持续时间延长至9秒"
                            },
                            {
                                "layer": 9,
                                "value": "所有技能造成的破绽效果可叠加4层，持续时间延长至12秒"
                            },
                            {
                                "layer": 10,
                                "value": "所有技能造成的破绽效果可叠加5层，持续时间延长至15秒"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "月碎对“破绽”状态下的敌人造成伤害额外提升7.5%"
                            },
                            {
                                "layer": 14,
                                "value": "月碎对“破绽”状态下的敌人造成伤害额外提升15%"
                            },
                            {
                                "layer": 15,
                                "value": "月碎对“破绽”状态下的敌人造成伤害额外提升22.5%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "使用月碎后额外增加0.5点左系无双和1点右系无双，触发间隔1秒"
                            },
                            {
                                "layer": 4,
                                "value": "使用月碎后额外增加1点左系无双和2点右系无双，触发间隔1秒"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 5,
                                "value": "月碎造成破绽效果的概率提升至40%"
                            },
                            {
                                "layer": 6,
                                "value": "月碎造成破绽效果的概率提升至60%"
                            },
                            {
                                "layer": 7,
                                "value": "月碎造成破绽效果的概率提升至80%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能获得无双值提高10%"
                            },
                            {
                                "layer": 4,
                                "value": "技能获得无双值提高20%"
                            },
                            {
                                "layer": 5,
                                "value": "技能获得无双值提高30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {},
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "“剑心”状态下，月碎暴击降低目标10%移速3秒，冷却5秒；“龙魂”状态下，月碎暴击提升自身10%移速3秒，冷却5秒"
                            },
                            {
                                "layer": 4,
                                "value": "“剑心”状态下，月碎暴击降低目标20%移速3秒，冷却5秒；“龙魂”状态下，月碎暴击提升自身20%移速3秒，冷却5秒"
                            },
                            {
                                "layer": 5,
                                "value": "“剑心”状态下，月碎暴击降低目标30%移速3秒，冷却5秒；“龙魂”状态下，月碎暴击提升自身30%移速3秒，冷却5秒"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "月碎无视目标3%的物理防御；"
                            },
                            {
                                "layer": 9,
                                "value": "月碎无视目标6%的物理防御；"
                            },
                            {
                                "layer": 10,
                                "value": "月碎无视目标10%的物理防御；"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "月碎对12米范围内敌人造成伤害有3%概率造成击退2米效果，触发间隔2秒"
                            },
                            {
                                "layer": 14,
                                "value": "月碎对12米范围内敌人造成伤害有6%概率造成击退2米效果，触发间隔2秒"
                            },
                            {
                                "layer": 15,
                                "value": "月碎对12米范围内敌人造成伤害有10%概率造成击退2米效果，触发间隔2秒"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {},
                    {}
                ]
            ]
        }
    },
    {
        "skillName": "鳞追",
        "skillProperty": [
            "物理攻击",
            "瞬发技能"
        ],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_1f3a2969-ea3f-4bcc-b80b-efbcf6cd537c_1902",
        "skillDescribe": {
            "main": "向自身前方划出3道龙鳞，靠近自身的敌人将受到至多3次伤害",
            "static": [
                "每道龙鳞有50%概率附加1层破绽状态"
            ],
            "addition": [
                {
                    "initiative": "每道龙鳞有50%概率附加1层破绽状态"
                }
            ],
            "trainingName": [
                "剑",
                "悟",
                "龙"
            ],
            "training": [
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "每道龙鳞伤害提升5%"
                            },
                            {
                                "layer": 4,
                                "value": "每道龙鳞伤害提升10%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "每道龙鳞对处于破绽状态的目标造成伤害额外提升13%"
                            },
                            {
                                "layer": 9,
                                "value": "每道龙鳞对处于破绽状态的目标造成伤害额外提升26%"
                            },
                            {
                                "layer": 10,
                                "value": "每道龙鳞对处于破绽状态的目标造成伤害额外提升39%"
                            }
                        ],
                        "require": {
                            "books": "中级麟追卷一*剑",
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "每道龙鳞对怪物造成伤害额外提高7.5%"
                            },
                            {
                                "layer": 4,
                                "value": "每道龙鳞对怪物造成伤害额外提高15%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {},
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能获得无双值提高10%"
                            },
                            {
                                "layer": 4,
                                "value": "技能获得无双值提高20%"
                            },
                            {
                                "layer": 5,
                                "value": "技能获得无双值提高30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "技能冷却时间降低7%"
                            },
                            {
                                "layer": 9,
                                "value": "技能冷却时间降低14%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "目标每被1道龙鳞命中，有11%概率弱疗，降低10%受治疗加强率3秒，可叠加3层"
                            },
                            {
                                "layer": 4,
                                "value": "目标每被1道龙鳞命中，有22%概率弱疗，降低10%受治疗加强率3秒，可叠加3层"
                            },
                            {
                                "layer": 5,
                                "value": "目标每被1道龙鳞命中，有33%概率弱疗，降低10%受治疗加强率3秒，可叠加3层"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "目标每被1道龙鳞命中，有11%概率缓速封印，降低30%移动速度和禁轻功3秒，可叠加3层"
                            },
                            {
                                "layer": 9,
                                "value": "目标每被1道龙鳞命中，有22%概率缓速封印，降低30%移动速度和禁轻功3秒，可叠加3层"
                            },
                            {
                                "layer": 10,
                                "value": "目标每被1道龙鳞命中，有33%概率缓速封印，降低30%移动速度和禁轻功3秒，可叠加3层"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "目标每被1道龙鳞命中，有11%概率碎甲，降低4%物法防和护甲3秒，可叠加3层"
                            },
                            {
                                "layer": 14,
                                "value": "目标每被1道龙鳞命中，有22%概率碎甲，降低4%物法防和护甲3秒，可叠加3层"
                            },
                            {
                                "layer": 15,
                                "value": "目标每被1道龙鳞命中，有33%概率碎甲，降低4%物法防和护甲3秒，可叠加3层"
                            }
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 5,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {},
                    {}
                ]
            ]
        }
    },
    {
        "skillName": "剑·龙旋",
        "skillProperty": [
            "物理攻击",
            "瞬发技能"
        ],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_8abb7f5f-57e2-4733-b087-b6407e6478f8_1904",
        "skillDescribe": {
            "main": "剑心形态下可用本技能：召唤地龙围绕自身游走并撞地炸裂，分别对0-7米敌人造成伤害",
            "static": [
                "地龙游走结束后地龙轰击地面，对0-7米的敌人造成物理伤害"
            ],
            "trainingName": [
                "剑",
                "悟",
                "龙"
            ],
            "training": [
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "本技能造成的所有伤害提升5%"
                            },
                            {
                                "layer": 4,
                                "value": "本技能造成的所有伤害提升10%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "被龙旋一段命中的敌人，受到治疗效果降低7.5%，持续2秒"
                            },
                            {
                                "layer": 9,
                                "value": "被龙旋一段命中的敌人，受到治疗效果降低15%，持续2秒"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "被龙旋一段命中的敌人，受到的伤害提高1.5%，持续5秒"
                            },
                            {
                                "layer": 14,
                                "value": "被龙旋一段命中的敌人，受到的伤害提高3%，持续5秒"
                            },
                            {
                                "layer": 15,
                                "value": "被龙旋一段命中的敌人，受到的伤害提高5%，持续5秒"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "本技能对怪物造成的伤害额外提高7.5%"
                            },
                            {
                                "layer": 4,
                                "value": "本技能对怪物造成的伤害额外提高15%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {},
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能获得无双值提高10%"
                            },
                            {
                                "layer": 4,
                                "value": "技能获得无双值提高20%"
                            },
                            {
                                "layer": 5,
                                "value": "技能获得无双值提高30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "技能冷却时间降低7%"
                            },
                            {
                                "layer": 9,
                                "value": "技能冷却时间降低14%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "龙旋一段环形路径（7-10米）造成的伤害提升20%"
                            },
                            {
                                "layer": 4,
                                "value": "龙旋一段环形路径（7-10米）造成的伤害提升40%"
                            },
                            {
                                "layer": 5,
                                "value": "龙旋一段环形路径（7-10米）造成的伤害提升60%，且额外附带2秒80%减速效果"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "龙旋二段环形路径（7-10米）造成的伤害提升20%"
                            },
                            {
                                "layer": 9,
                                "value": "龙旋二段环形路径（7-10米）造成的伤害提升40%"
                            },
                            {
                                "layer": 10,
                                "value": "龙旋二段环形路径（7-10米）造成的伤害提升60%，并附加1秒眩晕效果"
                            }
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 3,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "本技能对处于破绽状态的目标造成伤害额外提升13%"
                            },
                            {
                                "layer": 14,
                                "value": "本技能对处于破绽状态的目标造成伤害额外提升26%"
                            },
                            {
                                "layer": 15,
                                "value": "本技能对处于破绽状态的目标造成伤害额外提升39%"
                            }
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 6,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {},
                    {}
                ]
            ]
        }
    },
    {
        "skillName": "剑·杀合",
        "skillProperty": [
            "物理技能",
            "瞬发技能"
        ],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_1cd0a12f-11c1-4ce8-a955-25fa8636c986_1905",
        "skillDescribe": {
            "main": "剑心形态下可用本技能；将自身面前和身后各6*16米矩形范围内的敌人推开拉回，在距离自身8米处聚集，造成伤害和眩晕",
            "static": [
                "剑心形态下可用本技能；将自身面前和身后各6*16米矩形范围内的敌人推开拉回，在距离自身8米处聚集，造成伤害和眩晕"
            ],
            "trainingName": [
                "剑",
                "悟",
                "龙"
            ],
            "training": [
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "被剑·杀合命中的敌人有100%概率被附加1层破绽效果"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "本技能造成的伤害提升6%"
                            },
                            {
                                "layer": 9,
                                "value": "本技能造成的伤害提升12%"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 2,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "本技能对处于“破绽”状态下的目标，造成伤害额外提升12%"
                            },
                            {
                                "layer": 14,
                                "value": "本技能对处于“破绽”状态下的目标，造成伤害额外提升24%"
                            },
                            {
                                "layer": 15,
                                "value": "本技能对处于“破绽”状态下的目标，造成伤害额外提升36%"
                            }
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 5,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "本技能对怪物造成伤害额外提高7.5%"
                            },
                            {
                                "layer": 4,
                                "value": "本技能对怪物造成伤害额外提高15%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "本技能的控制等级提升5级"
                            },
                            {
                                "layer": 4,
                                "value": "本技能的控制等级提升10级"
                            },
                            {
                                "layer": 5,
                                "value": "本技能的控制等级提升15级"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "59"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能获得无双值提高10%"
                            },
                            {
                                "layer": 4,
                                "value": "技能获得无双值提高20%"
                            },
                            {
                                "layer": 5,
                                "value": "技能获得无双值提高30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能冷却时间降低5%"
                            },
                            {
                                "layer": 4,
                                "value": "技能冷却时间降低10%"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "59"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "被推拉命中的目标额外受到破甲效果，物法防下降1%，持续5秒"
                            },
                            {
                                "layer": 4,
                                "value": "被推拉命中的目标额外受到破甲效果，物法防下降2%，持续5秒"
                            },
                            {
                                "layer": 5,
                                "value": "被推拉命中的目标额外受到破甲效果，物法防下降3%，持续5秒"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "使用技能后自身获得物伤提升状态，物理伤害提升2%，持续5秒"
                            },
                            {
                                "layer": 9,
                                "value": "使用技能后自身获得物伤提升状态，物理伤害提升4%，持续5秒"
                            },
                            {
                                "layer": 10,
                                "value": "使用技能后自身获得物伤提升状态，物理伤害提升6%，持续5秒"
                            }
                        ],
                        "require": {
                            "preNum": 2,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "本技能的推拉效果可无视敌人的霸体状态（仍受控制等级影响）且不再对怪物生效，控制等级额外提升10级，但冷却时间提高3秒"
                            },
                            {},
                            {}
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 5,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "剑·杀合使用后，自身立即后退8米，且移除推拉效果"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {},
                    {}
                ]
            ]
        }
    },
    {
        "skillName": "凌突",
        "skillProperty": [
            "物理技能",
            "瞬发技能"
        ],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_58de7e28-0317-40a3-99af-fabd591052ad_1907",
        "skillDescribe": {
            "main": "启动凌突-闪避形态，使自身获得10%闪避率以应对下一次伤害，同时瞬移至锁定目标位置并造成伤害",
            "static": [
                "瞬间移动到目标面前，发动攻击造成物理伤害"
            ],
            "addition": [
                {
                    "initiative": "被凌突一斩命中的目标获得眩晕状态",
                    "passivity": "眩晕：无法移动和使用技能、轻功"
                }
            ],
            "trainingName": [
                "剑",
                "悟",
                "龙"
            ],
            "training": [
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "本技能造成的伤害提升5%"
                            },
                            {
                                "layer": 4,
                                "value": "本技能造成的伤害提升10%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "使用凌突一斩后5秒内自身控制等级提升2级"
                            },
                            {
                                "layer": 9,
                                "value": "使用凌突一斩后5秒内自身控制等级提升4级"
                            },
                            {
                                "layer": 10,
                                "value": "使用凌突一斩后5秒内自身控制等级提升6级"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "自身处于凌突闪避状态时，受到的下1次攻击伤害减免8%"
                            },
                            {
                                "layer": 14,
                                "value": "自身处于凌突闪避状态时，受到的下1次攻击伤害减免16%"
                            },
                            {
                                "layer": 15,
                                "value": "自身处于凌突闪避状态时，受到的下1次攻击伤害减免25%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "本技能造成的伤害对怪物额外提高7.5%"
                            },
                            {
                                "layer": 4,
                                "value": "本技能造成的伤害对怪物额外提高15%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "自身处于凌突闪避状态时，受到的下1次攻击使自身获得1层看破效果"
                            },
                            {
                                "layer": 9,
                                "value": "自身处于凌突闪避状态时，受到的下1次攻击使自身获得2层看破效果"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能获得无双值提高10%"
                            },
                            {
                                "layer": 4,
                                "value": "技能获得无双值提高20%"
                            },
                            {
                                "layer": 5,
                                "value": "技能获得无双值提高30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "技能冷却时间降低7%"
                            },
                            {
                                "layer": 9,
                                "value": "技能冷却时间降低14%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "凌突一斩使自身增加1层看破，并提升0.5%物理伤害5秒"
                            },
                            {
                                "layer": 4,
                                "value": "凌突一斩使自身增加1层看破，并提升1%物理伤害5秒"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "凌突一斩将攻击的目标碎甲5秒，降低3%物理和法术防御"
                            },
                            {
                                "layer": 9,
                                "value": "凌突一斩将攻击的目标碎甲5秒，降低6%物理和法术防御"
                            },
                            {
                                "layer": 10,
                                "value": "凌突一斩将攻击的目标碎甲5秒，降低9%物理和法术防御"
                            }
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 3,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "凌突一斩使用后5秒内，自身受到伤害后瞬间移动到攻击自己的目标面前，发动攻击造成本体技能20%的伤害"
                            },
                            {
                                "layer": 14,
                                "value": "凌突一斩使用后5秒内，自身受到伤害后瞬间移动到攻击自己的目标面前，发动攻击造成本体技能20%的伤害，并将目标定身2秒"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 2,
                            "totolNum": 5,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {},
                    {}
                ]
            ]
        }
    },
    {
        "skillName": "风裂",
        "skillProperty": [
            "物理技能",
            "引导技能"
        ],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_df63e581-30e5-41c5-b493-04cd1d2fa7e9_1906",
        "skillDescribe": {
            "main": "召唤撕裂风暴环绕自身，半径10米范围内触碰到风裂的敌人会受到伤害并被减速；5秒内使用二斩可向25米内锁定目标进行攻击",
            "static": [
                "风裂环绕时每0.5秒对触碰到的敌人造成物理伤害"
            ],
            "addition": [
                {
                    "initiative": "触碰到环绕风裂的目标获得减速状态"
                }
            ],
            "trainingName": [
                "剑",
                "悟",
                "龙"
            ],
            "training": [
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "剑心形态下：风裂环绕时造成的伤害提高10%；龙魂形态下：风裂环绕时附带的减速效果提升至50%"
                            },
                            {
                                "layer": 4,
                                "value": "剑心形态下：风裂环绕时造成的伤害提高20%；龙魂形态下：风裂环绕时附带的减速效果提升至60%"
                            },
                            {
                                "layer": 5,
                                "value": "剑心形态下：风裂环绕时造成的伤害提高30%；龙魂形态下：风裂环绕时附带的减速效果提升至70%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "剑心形态下：风裂环绕时有10%概率造成定身效果2秒；龙魂形态下：风裂环绕时自身提升1.5%物理和法术防御"
                            },
                            {
                                "layer": 9,
                                "value": "剑心形态下：风裂环绕时有20%概率造成定身效果2秒；龙魂形态下：风裂环绕时自身提升3%物理和法术防御"
                            },
                            {
                                "layer": 10,
                                "value": "剑心形态下：风裂环绕时有30%概率造成定身效果2秒；龙魂形态下：风裂环绕时自身提升4.5%物理和法术防御"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "本技能对怪物造成的伤害额外提高7.5%"
                            },
                            {
                                "layer": 4,
                                "value": "本技能对怪物造成的伤害额外提高15%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {},
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "剑心形态下：风裂二斩伤害提升10%；龙魂形态下：风裂二斩对目标造成眩晕效果，持续0.5秒"
                            },
                            {
                                "layer": 14,
                                "value": "剑心形态下：风裂二斩伤害提升20%；龙魂形态下：风裂二斩对目标造成眩晕效果，持续1秒"
                            },
                            {
                                "layer": 15,
                                "value": "剑心形态下：风裂二斩伤害提升30%；龙魂形态下：风裂二斩对目标造成眩晕效果，持续2秒"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能获得无双值提高10%"
                            },
                            {
                                "layer": 4,
                                "value": "技能获得无双值提高20%"
                            },
                            {
                                "layer": 5,
                                "value": "技能获得无双值提高30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "技能冷却时间降低7%"
                            },
                            {
                                "layer": 9,
                                "value": "技能冷却时间降低14%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "使用风裂有100%概率立即获得1层看破效果"
                            },
                            {
                                "layer": 4,
                                "value": "使用风裂有100%概率立即获得2层看破效果"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "剑心形态下：风裂二斩附带破甲效果，降低目标1.5%物理法术防御和护甲，持续3秒；龙魂形态下：风裂二斩附带碎刃效果，降低目标1.5%物理法术伤害，持续3秒"
                            },
                            {
                                "layer": 9,
                                "value": "剑心形态下：风裂二斩附带破甲效果，降低目标3%物理法术防御和护甲，持续3秒；龙魂形态下：风裂二斩附带碎刃效果，降低目标3%物理法术伤害，持续3秒"
                            },
                            {
                                "layer": 10,
                                "value": "剑心形态下：风裂二斩附带破甲效果，降低目标4.5%物理法术防御和护甲，持续3秒；龙魂形态下：风裂二斩附带碎刃效果，降低目标4.5%物理法术伤害，持续3秒"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "剑心形态下：风裂环绕时提升自身1.5%物理法术伤害加深率；龙魂形态下：风裂环绕时提升自身1.5%物理法术伤害减免率"
                            },
                            {
                                "layer": 14,
                                "value": "剑心形态下：风裂环绕时提升自身3%物理法术伤害加深率；龙魂形态下：风裂环绕时提升自身3%物理法术伤害减免率"
                            },
                            {
                                "layer": 15,
                                "value": "剑心形态下：风裂环绕时提升自身4.5%物理法术伤害加深率；龙魂形态下：风裂环绕时提升自身4.5%物理法术伤害减免率"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "剑心和龙魂形态下：自身无双获取效率提升1.5%（可与其他增长效果叠加）"
                            },
                            {
                                "layer": 4,
                                "value": "剑心和龙魂形态下：自身无双获取效率提升3%（可与其他增长效果叠加）"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "自身处于“看破”状态时，造成伤害无视自身赋予“破绽”状态目标的技能减伤效果提升至3%（每层破绽效果均受此提升）"
                            },
                            {
                                "layer": 9,
                                "value": "自身处于“看破”状态时，造成伤害无视自身赋予“破绽”状态目标的技能减伤效果提升至4%（每层破绽效果均受此提升）"
                            },
                            {
                                "layer": 10,
                                "value": "自身处于“看破”状态时，造成伤害无视自身赋予“破绽”状态目标的技能减伤效果提升至5%（每层破绽效果均受此提升）"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "每次切换形态后，5秒内提升1%暴击率，并提升形态对应防御力1%（剑心形态法术防御，龙魂形态物理防御）"
                            },
                            {
                                "layer": 14,
                                "value": "每次切换形态后，5秒内提升2%暴击率，并提升形态对应防御力2%（剑心形态法术防御，龙魂形态物理防御）"
                            },
                            {
                                "layer": 15,
                                "value": "每次切换形态后，5秒内提升3%暴击率，并提升形态对应防御力3%（剑心形态法术防御，龙魂形态物理防御）"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ]
            ]
        }
    },
    {
        "skillName": "化龙",
        "skillProperty": [
            "辅助技能",
            "瞬发技能"
        ],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_9b7455b7-cf96-45ce-92ae-40dfdeec232f_1908",
        "skillDescribe": {
            "main": "使自己切换为<font color='#66CD00'>剑心</font>或者<font color='#66CD00'>龙魂</font>形态，并回复对应系无双值",
            "static": [
                "剑心形态下可使用技能剑·龙旋、剑·杀合、剑·如龙，龙魂形态下可使用技能龙·游世、龙·天返、龙·战甲"
            ],
            "addition": [
                {
                    "initiative": "切换为剑心形态，自己造成的技能伤害变为物理伤害，提升法术防御，并回复左系无双值；切换为龙魂形态，自己造成的技能伤害变为法术伤害，提升物理防御，并回复右系无双值"
                }
            ],
            "trainingName": [
                "剑",
                "悟",
                "龙"
            ],
            "training": [
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "剑心和龙魂形态下：自身无双获取效率提升1.5%（可与其他增长效果叠加）"
                            },
                            {
                                "layer": 4,
                                "value": "剑心和龙魂形态下：自身无双获取效率提升3%（可与其他增长效果叠加）"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "自身处于“看破”状态时，造成伤害无视自身赋予“破绽”状态目标的技能减伤效果提升至3%（每层破绽效果均受此提升）"
                            },
                            {
                                "layer": 9,
                                "value": "自身处于“看破”状态时，造成伤害无视自身赋予“破绽”状态目标的技能减伤效果提升至4%（每层破绽效果均受此提升）"
                            },
                            {
                                "layer": 10,
                                "value": "自身处于“看破”状态时，造成伤害无视自身赋予“破绽”状态目标的技能减伤效果提升至5%（每层破绽效果均受此提升）"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "每次切换形态后，5秒内提升1%暴击率，并提升形态对应防御力1%（剑心形态法术防御，龙魂形态物理防御）"
                            },
                            {
                                "layer": 14,
                                "value": "每次切换形态后，5秒内提升2%暴击率，并提升形态对应防御力2%（剑心形态法术防御，龙魂形态物理防御）"
                            },
                            {
                                "layer": 15,
                                "value": "每次切换形态后，5秒内提升3%暴击率，并提升形态对应防御力3%（剑心形态法术防御，龙魂形态物理防御）"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 5,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {},
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能获得无双值提高10%"
                            },
                            {
                                "layer": 4,
                                "value": "技能获得无双值提高20%"
                            },
                            {
                                "layer": 5,
                                "value": "技能获得无双值提高30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {},
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "剑心和龙魂形态下：自身物理伤害提升30点"
                            },
                            {
                                "layer": 4,
                                "value": "剑心和龙魂形态下：自身物理伤害提升60点"
                            },
                            {
                                "layer": 5,
                                "value": "剑心和龙魂形态下：自身物理伤害提升90点"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "剑心和龙魂形态下，自身暴击力提高60点"
                            },
                            {
                                "layer": 9,
                                "value": "剑心和龙魂形态下，自身暴击力提高120点"
                            },
                            {
                                "layer": 10,
                                "value": "剑心和龙魂形态下，自身暴击力提高180点"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 1,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "化龙技能在被控状态下可以使用"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "剑心和龙魂形态下，自身对怪物造成伤害提升3%"
                            },
                            {
                                "layer": 9,
                                "value": "剑心和龙魂形态下，自身对怪物造成伤害提升6%"
                            },
                            {
                                "layer": 10,
                                "value": "剑心和龙魂形态下，自身对怪物造成伤害提升10%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 1,
                            "line": "59"
                        }
                    },
                    {}
                ]
            ]
        }
    },
    {
        "skillName": "龙·游世",
        "skillProperty": [
            "物理技能",
            "瞬发技能"
        ],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_3c688925-98eb-4eed-80c1-a6a5ea8c17fc_1903",
        "skillDescribe": {
            "main": "<font color='#66CD00'>龙魂</font>形态下可用本技能：召唤二条龙弧线移动，对路径上的敌方造成伤害",
            "static": [
                "每条游龙对路径上的敌人造成物理伤害和眩晕效果，二条游龙会在12米处交汇，对交汇处敌人造成2次伤害"
            ],
            "trainingName": [
                "剑",
                "悟",
                "龙"
            ],
            "training": [
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "每条游龙伤害提升5%"
                            },
                            {
                                "layer": 4,
                                "value": "每条游龙伤害提升10%"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "每条游龙对处于破绽状态的目标造成伤害额外提升10%"
                            },
                            {
                                "layer": 9,
                                "value": "每条游龙对处于破绽状态的目标造成伤害额外提升20%"
                            },
                            {
                                "layer": 10,
                                "value": "每条游龙对处于破绽状态的目标造成伤害额外提升30%"
                            }
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 3,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "游龙对交汇处的敌人造成伤害额外提升12%"
                            },
                            {
                                "layer": 14,
                                "value": "游龙对交汇处的敌人造成伤害额外提升24%"
                            },
                            {
                                "layer": 15,
                                "value": "游龙对交汇处的敌人造成伤害额外提升36%"
                            }
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 6,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "每条游龙对怪物造成伤害额外提高7.5%"
                            },
                            {
                                "layer": 4,
                                "value": "每条游龙对怪物造成伤害额外提高15%"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {},
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能获得无双值提高10%"
                            },
                            {
                                "layer": 4,
                                "value": "技能获得无双值提高20%"
                            },
                            {
                                "layer": 5,
                                "value": "技能获得无双值提高30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "技能冷却时间降低7%"
                            },
                            {
                                "layer": 9,
                                "value": "技能冷却时间降低14%"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "游龙立即驱散被命中的敌人1个（1层）正面状态"
                            },
                            {
                                "layer": 4,
                                "value": "游龙立即驱散被命中的敌人2个（各2层）正面状态"
                            },
                            {
                                "layer": 5,
                                "value": "游龙立即驱散被命中的敌人3个（各2层）正面状态"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "每驱散1个敌方正面状态自身立即获得100点暴击力5秒"
                            },
                            {
                                "layer": 9,
                                "value": "每驱散1个敌方正面状态自身立即获得200点暴击力5秒"
                            },
                            {
                                "layer": 10,
                                "value": "每驱散1个敌方正面状态自身立即获得300点暴击力5秒"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "标记交叉处被眩晕的敌人，若4秒内未能离开交叉点10米，则会被立即拉回至交叉处"
                            },
                            {
                                "layer": 14,
                                "value": "标记交叉处被眩晕的敌人，若3秒内未能离开交叉点10米，则会被立即拉回至交叉处"
                            },
                            {
                                "layer": 15,
                                "value": "标记交叉处被眩晕的敌人，若2秒内未能离开交叉点10米，则会被立即拉回至交叉处，并被驱散1个（1层）正面状态"
                            }
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 5,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {},
                    {}
                ]
            ]
        }
    },
    {
        "skillName": "龙·天返",
        "skillProperty": [
            "物理技能",
            "瞬发技能"
        ],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_3d3dce13-f4c5-4fc5-9416-ec950864a6a0_1909",
        "skillDescribe": {
            "main": "龙魂</font>形态下可用本技能；将前方扇形范围内敌方拉回点并击晕，同时自身向后移动；二斩拔剑对前方矩形范围造成伤害",
            "static": [
                "向前方12米扇形范围施展攻击，造成物理伤害将范围内敌方拉回至攻击中心点并眩晕；施展同时自身向后移动12米"
            ],
            "trainingName": [
                "剑",
                "悟",
                "龙"
            ],
            "training": [
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "本技能造成的所有伤害提升5%"
                            },
                            {
                                "layer": 4,
                                "value": "本技能造成的所有伤害提升10%"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "天返一斩使自身获得暴击提升状态，暴击率提升1%，持续5秒"
                            },
                            {
                                "layer": 9,
                                "value": "天返一斩使自身获得暴击提升状态，暴击率提升2%，持续5秒"
                            },
                            {
                                "layer": 10,
                                "value": "天返一斩使自身获得暴击提升状态，暴击率提升3%，持续5秒"
                            }
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 3,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "天返一斩造成的眩晕效果额外增加0.5秒"
                            },
                            {
                                "layer": 14,
                                "value": "天返一斩造成的眩晕效果额外增加1秒"
                            }
                        ],
                        "require": {
                            "preNum": 2,
                            "totolNum": 5,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "本技能对怪物造成伤害额外提高7.5%"
                            },
                            {
                                "layer": 4,
                                "value": "本技能对怪物造成伤害额外提高15%"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "本技能的推拉效果控制等级额外提升5级"
                            },
                            {
                                "layer": 9,
                                "value": "本技能的推拉效果控制等级额外提升10级"
                            },
                            {
                                "layer": 10,
                                "value": "本技能的推拉效果控制等级额外提升15级，可无视敌人的霸体状态（仍受控制等级影响）且不再对怪物生效，但冷却时间提高6秒"
                            }
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 3,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "天返二斩可在被控状态下使用"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 5,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能获得无双值提高10%"
                            },
                            {
                                "layer": 4,
                                "value": "技能获得无双值提高20%"
                            },
                            {
                                "layer": 5,
                                "value": "技能获得无双值提高30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "技能冷却时间降低5%"
                            },
                            {
                                "layer": 9,
                                "value": "技能冷却时间降低10%"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "龙·天返二斩伤害额外提高10%"
                            },
                            {
                                "layer": 4,
                                "value": "龙·天返二斩伤害额外提高20%"
                            },
                            {
                                "layer": 5,
                                "value": "龙·天返二斩伤害额外提高30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "龙·天返二斩无视敌方10%法术防御"
                            },
                            {
                                "layer": 9,
                                "value": "龙·天返二斩无视敌方20%法术防御"
                            },
                            {
                                "layer": 10,
                                "value": "龙·天返二斩无视敌方30%法术防御"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "龙·天返二斩造成伤害结算时额外附加200点暴击力"
                            },
                            {
                                "layer": 14,
                                "value": "龙·天返二斩造成伤害结算时额外附加400点暴击力"
                            },
                            {
                                "layer": 15,
                                "value": "龙·天返二斩造成伤害结算时额外附加600点暴击力"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {},
                    {}
                ]
            ]
        }
    },
    {
        "skillName": "英域",
        "skillProperty": [
            "物理技能",
            "瞬发技能"
        ],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_05ed5bef-a046-460b-867c-61e0cc72d24a_1910",
        "skillDescribe": {
            "main": "在原地召唤一个半径15米的英域，英域内自身和友方战斗能力得到强化，敌方受到治疗效果降低",
            "static": [
                "英域持续5秒"
            ],
            "addition": [
                {
                    "initiative": "英域内的友方和英灵持续获得英域-激发状态"
                }
            ],
            "trainingName": [
                "剑",
                "悟",
                "龙"
            ],
            "training": [
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "英域内己方无双增长速度提高3%（同类效果无法共存）"
                            },
                            {
                                "layer": 4,
                                "value": "英域内己方无双增长速度提高6%（同类效果无法共存）"
                            },
                            {
                                "layer": 5,
                                "value": "英域内己方无双增长速度提高9%（同类效果无法共存）"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "英域内自身、队友和友方英灵每2秒获得普技加深状态，提升0.3%普技加深率，可叠加3层，持续6秒"
                            },
                            {
                                "layer": 9,
                                "value": "英域内自身、队友和友方英灵每2秒获得普技加深状态，提升0.6%普技加深率，可叠加3层，持续6秒"
                            },
                            {
                                "layer": 10,
                                "value": "英域内自身、队友和友方英灵每2秒获得普技加深状态，提升1%普技加深率，可叠加3层，持续6秒"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "英域持续时间延长0.5秒"
                            },
                            {
                                "layer": 14,
                                "value": "英域持续时间延长1秒"
                            },
                            {
                                "layer": 15,
                                "value": "英域持续时间延长1.5秒"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "英域内己方英灵攻击额外提高4.5%"
                            },
                            {
                                "layer": 4,
                                "value": "英域内己方英灵攻击额外提高9%"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "英域内敌方每2秒获得防御和护甲降低状态，降低1.5%物法防，可叠加3层，持续6秒"
                            },
                            {
                                "layer": 9,
                                "value": "英域内敌方每2秒获得防御和护甲降低状态，降低3%物法防，可叠加3层，持续6秒"
                            },
                            {
                                "layer": 10,
                                "value": "英域内敌方每2秒获得防御和护甲降低状态，降低4.5%物法防，可叠加3层，持续6秒"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能获得无双值提高10%"
                            },
                            {
                                "layer": 4,
                                "value": "技能获得无双值提高20%"
                            },
                            {
                                "layer": 5,
                                "value": "技能获得无双值提高30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "技能冷却时间降低7%"
                            },
                            {
                                "layer": 9,
                                "value": "技能冷却时间降低14%"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能使用后自身立即获得1层看破状态，且英域内敌人每2秒有50%概率被施加1层破绽效果"
                            },
                            {
                                "layer": 4,
                                "value": "技能使用后自身立即获得2层看破状态，且英域内敌人每2秒有100%概率被施加1层破绽效果"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "英域内敌人获得“偏斜”效果，命中率下降6%"
                            },
                            {
                                "layer": 9,
                                "value": "英域内敌人获得“偏斜”效果，命中率下降12%"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "英域12米半径内敌人会被附加视野遮罩效果（视野封闭，周围变黑暗），且普通技能冷却时间减缓10%"
                            },
                            {
                                "layer": 14,
                                "value": "英域12米半径内敌人会被附加视野遮罩效果（视野封闭，周围变黑暗），且普通技能冷却时间减缓20%"
                            },
                            {
                                "layer": 15,
                                "value": "英域12米半径内敌人会被附加视野遮罩效果（视野封闭，周围变黑暗），且普通技能冷却时间减缓30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {},
                    {}
                ]
            ]
        }
    },
    {
        "skillName": "剑·如龙",
        "skillProperty": [
            "辅助技能",
            "瞬发技能"
        ],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_f57c01a6-d7d4-400c-9467-5145948b17c1_1911",
        "skillDescribe": {
            "main": "剑心形态下可用本技能；龙影伴身，解除控制并进入霸体状态，提升移动速度；使用本技能后降低大量仇恨值",
            "static": [
                "解除控制并进入如龙-霸体状态，提升移动速度"
            ],
            "addition": [],
            "trainingName": [
                "剑",
                "悟",
                "龙"
            ],
            "training": [
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "如龙状态期间自身被暴击立即获得5%伤害减免效果3秒，触发间隔5秒"
                            },
                            {
                                "layer": 4,
                                "value": "如龙状态期间自身被暴击立即获得10%伤害减免效果3秒，触发间隔5秒"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "如龙状态持续时间增加0.5秒"
                            },
                            {
                                "layer": 9,
                                "value": "如龙状态持续时间增加1秒"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "如龙状态期间自身造成暴击概率提高5%"
                            },
                            {
                                "layer": 14,
                                "value": "如龙状态期间自身造成暴击概率提高10%"
                            },
                            {
                                "layer": 15,
                                "value": "如龙状态期间自身造成暴击概率提高15%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "使用剑·如龙后，10秒内对怪物造成伤害提高5%"
                            },
                            {
                                "layer": 4,
                                "value": "使用剑·如龙后，10秒内对怪物造成伤害提高10%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {},
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能获得无双值提高10%"
                            },
                            {
                                "layer": 4,
                                "value": "技能获得无双值提高20%"
                            },
                            {
                                "layer": 5,
                                "value": "技能获得无双值提高30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "技能冷却时间降低7%"
                            },
                            {
                                "layer": 9,
                                "value": "技能冷却时间降低14%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "如龙状态持续期间自身移动速度提升20%"
                            },
                            {
                                "layer": 4,
                                "value": "如龙状态持续期间自身移动速度提升40%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "如龙状态期间自身受到的治疗效果提升6%"
                            },
                            {
                                "layer": 9,
                                "value": "如龙状态期间自身受到的治疗效果提升12%"
                            },
                            {
                                "layer": 10,
                                "value": "如龙状态期间自身受到的治疗效果提升18%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "如龙状态期间，自身造成暴击可立即回复2点左系和右系无双值，触发间隔1秒"
                            },
                            {
                                "layer": 14,
                                "value": "如龙状态期间，自身造成暴击可立即回复4点左系和右系无双值，触发间隔1秒"
                            },
                            {
                                "layer": 15,
                                "value": "如龙状态期间，自身造成暴击可立即回复6点左系和右系无双值，触发间隔1秒"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {},
                    {}
                ]
            ]
        }
    },
    {
        "skillName": "龙·战甲",
        "skillProperty": [
            "辅助技能",
            "瞬发技能"
        ],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_93ec6465-dc6e-47d5-b722-d1efa9f3e247_1912",
        "skillDescribe": {
            "main": "龙魂形态下可用本技能；解除控制并进入霸体状态，对自身施放战甲并获得护盾，战甲期间造成伤害可以持续获得护盾",
            "static": [
                "解除控制并进入霸体-战甲状态，持续0.5秒"
            ],
            "addition": [
                {
                    "initiative": "立即获得战甲-护盾状态：根据自身平均物理伤害获得护盾"
                }
            ],
            "trainingName": [
                "剑",
                "悟",
                "龙"
            ],
            "training": [
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能施放后根据自身平均物理伤害转换护盾的转换率提高5%，且战甲期间自身造成伤害转换护盾的比例提高2%"
                            },
                            {
                                "layer": 4,
                                "value": "技能施放后根据自身平均物理伤害转换护盾的转换率提高10%，且战甲期间自身造成伤害转换护盾的比例提高4%"
                            },
                            {
                                "layer": 5,
                                "value": "技能施放后根据自身平均物理伤害转换护盾的转换率提高15%，且战甲期间自身造成伤害转换护盾的比例提高6%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "战甲持续时间增加0.5秒"
                            },
                            {
                                "layer": 9,
                                "value": "战甲持续时间增加1秒"
                            },
                            {
                                "layer": 10,
                                "value": "战甲持续时间增加1.5秒"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "战甲期间自身获得6%吸血效果"
                            },
                            {
                                "layer": 14,
                                "value": "战甲期间自身获得12%吸血效果"
                            },
                            {
                                "layer": 15,
                                "value": "战甲期间自身获得20%吸血效果"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {},
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能获得无双值提高10%"
                            },
                            {
                                "layer": 4,
                                "value": "技能获得无双值提高20%"
                            },
                            {
                                "layer": 5,
                                "value": "技能获得无双值提高30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {},
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "战甲使用后霸体时间延长0.5秒"
                            },
                            {
                                "layer": 4,
                                "value": "战甲使用后霸体时间延长1.5秒"
                            },
                            {
                                "layer": 5,
                                "value": "战甲使用后霸体时间延长2.5秒"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "战甲状态期间若是受到的伤害超过了自身总血量的30%，则5秒内受到物理和法术伤害减免3%"
                            },
                            {
                                "layer": 9,
                                "value": "战甲状态期间若是受到的伤害超过了自身总血量的30%，则5秒内受到物理和法术伤害减免6%"
                            },
                            {
                                "layer": 10,
                                "value": "战甲状态期间若是受到的伤害超过了自身总血量的30%，则5秒内受到物理和法术伤害减免10%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "战甲期间自身暴击伤害减免率提高6%"
                            },
                            {
                                "layer": 14,
                                "value": "战甲期间自身暴击伤害减免率提高12%"
                            },
                            {
                                "layer": 15,
                                "value": "战甲期间自身暴击伤害减免率提高18%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {},
                    {}
                ]
            ]
        }
    }
]
module.exports=tianzhao;


//////////////////
// WEBPACK FOOTER
// ./pages/skillmacros/js/skill-tianzhao.js
// module id = 5
// module chunks = 0 1 3 4